/**
 * Update target for multi-target display injection (public/private display).
 *
 * EventFrame finds <anear-anchor> by the "name" attribute and applies content
 * from PRIVATE_DISPLAY or PARTICIPANTS_DISPLAY messages with { targets: { anchor: contentOrObj } }.
 * Each value is string (content) or { content, type?, contentType? } where:
 *   - type: 'replace'|'append' (default: replace)
 *   - contentType: 'html'|'text' (default: html)
 * Apply only when the element exists in the DOM; no staging or retry.
 *
 * Anchors are update targets, not compositional structure. Full-frame renders
 * include anchors with complete content; later updates replace or append to
 * specific anchors (e.g. score, card slot, seat).
 *
 * Usage in Pug: anear-anchor(name="player_1") or name=anyExpression
 * Anchor names are programmatic (e.g. player_${participantId}); no auto-qualification.
 */
class AnearAnchor extends HTMLElement {
  static get observedAttributes() {
    return ['name']
  }
}

if (!customElements.get('anear-anchor')) {
  customElements.define('anear-anchor', AnearAnchor)
}

export default AnearAnchor
